import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

// API POST Method

const employeeVisaPostFn = async (employeeData) => {
    let config = {
      method: "post",
      url: `/employee/api/v1/employee_visa/ `,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: employeeData,
    };
    
    return await axios.request(config);
  };
  export const useEmployeeVisaPostFn = () => {
    return useMutation(["employee-visa-post"], employeeVisaPostFn);
  };


  // API PATCH Method
  const employeeVisaUpdateFn = async (employeeData) => {
  
    let {id, userData} = employeeData;
    let config = {
      method: "patch",
      url: `/employee/api/v1/employee_visa/${id}/`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: userData,
    };
    
    return await axios.request(config);
  };
  export const useEmployeeVisaUpdateFn = () => {
    return useMutation(["employee-visa-update"], employeeVisaUpdateFn);
  };

 // API GET Method Using UUID

  const getEmployeeVisaByUUIDFn = async (query) => {
    let [, employee_uuid] = query.queryKey;
    let config = {
      method: "get",
      url: `/employee/api/v1/employee_visa/?employee__employee_uuid=${employee_uuid}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const response = await axios.request(config);
    return response?.data;
  };
  export const useGetEmployeeVisaByUUID = (employee_uuid) => {
    return useQuery(["get-employee-visa-by-uuid", employee_uuid], getEmployeeVisaByUUIDFn, {enabled: !!employee_uuid});
  };

  // API GET Method 
  const getEmployeeVisaByIDFn = async (query) => {
    let [, employee_id] = query.queryKey;
    let config = {
      method: "get",
      url: `/employee/api/v1/employee_visa/${employee_id}/`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const response = await axios.request(config);
    return response?.data;
  };
  export const useGetEmployeeVisaByID = (employee_id) => {
    return useQuery(["get-employee-visa-by-id", employee_id], getEmployeeVisaByIDFn, {enabled: false});
  }; 

  const getVisaFn = async () => {
    let config = {
      method: "get",
      url: "/employee/api/v1/employee_visa_type/",
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const response = await axios.request(config);
    return response?.data;
  };
  export const useVisaFn = () => {
    return useQuery(["get-visa"], getVisaFn);
  };